module.exports = __webpack_public_path__ + "static/media/vu.2a533042.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/vu.svg
// module id = 2243
// module chunks = 0